import { generatePath, useNavigate } from 'react-router-dom';

import { ActionText } from '@components/action-text';
import { IconIntegration } from '@components/icons/integration';
import { IntegrationList as CoreIntegrationList } from '@components/integrations';
import { Integration } from '@components/integrations/integrations-types';
import { SquareImage } from '@components/square-image';
import { useScopedTranslate } from '@locale/translate';

import { routePaths } from 'ui/authenticated/navigation';

export const renderIntegrationIcon = (integration: Integration) => {
  return integration.thumbnail ? <SquareImage src={integration.thumbnail} /> : <IconIntegration />;
};

export const Integrations = () => {
  const navigate = useNavigate();
  const { t, styledTranslate } = useScopedTranslate(locale);

  return (
    <CoreIntegrationList
      breadcrumbLabel={t('customIntegrations')}
      getIntegrationUrl={(integration: Integration) =>
        generatePath(routePaths.integrationDetail, {
          integrationId: integration.shortId,
          '*': null,
        })
      }
      onIntegrationCreated={(integration: Integration) => {
        navigate(
          generatePath(routePaths.integrationDetail, {
            integrationId: integration.shortId,
            '*': null,
          })
        );
      }}
      emptyStateContent={styledTranslate('noIntegrationsDescription', {
        action: (
          <ActionText.ExternalLink
            href="https://help.journeys.50skills.app/en/"
            color="textSecondary"
            underline
          >
            {t('aboutIntegrations')}
          </ActionText.ExternalLink>
        ),
      })}
      renderIntegrationIcon={(integration: Integration) => renderIntegrationIcon(integration)}
    />
  );
};

const locale = {
  en: {
    customIntegrations: 'Custom integrations',
    noIntegrationsDescription:
      'Create a custom connector to connect to a REST API.\nThe API must support one of 6 authentication methods and use JSON.\n{action}',
    aboutIntegrations: 'Learn more about integrations',
  },
};
